<h2 mat-dialog-title>Historia de registro</h2>
<mat-dialog-content class="mat-typography">
    <div class="container-table mat-elevation-z8">
        <table mat-table [dataSource]="dataSourceLogs">
            <!-- Columns -->
            <ng-container [matColumnDef]="column" *ngFor="let column of logsColumns">
            <th mat-header-cell *matHeaderCellDef> {{ column=='identificador' ? data.identificador : column  }} </th>
            <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="logsColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: logsColumns;"></tr>
        </table>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
